import { memo } from 'react'
import * as Styled from './styled'
import MusicVersioningTopSection from './top-section'
import { MUSIC_VERSIONING_OVERLAY_CLASSNAME } from './consts'
import RemoveAudioSection from './versions-section/remove-audio-section'
import MusicVersioningVersionsSection from './versions-section'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { Text } from 'common-components'
import { useSelectedLibSoundVersionsSelectorState } from './hooks'

const MusicVersioning = () => {
  const { hasSelectedLibSoundVersion } =
    useSelectedLibSoundVersionsSelectorState()

  return (
    <>
      <Styled.Header>
        <Text type="h1" color="secondaryDark" fontWeight="600">
          {translate(T.EDIT_AUDIO)}
        </Text>
      </Styled.Header>
      <Styled.MusicVersioningContainer
        className={MUSIC_VERSIONING_OVERLAY_CLASSNAME}
      >
        <MusicVersioningTopSection
          hideDivideLine={!hasSelectedLibSoundVersion}
        />

        {hasSelectedLibSoundVersion ? <MusicVersioningVersionsSection /> : null}

        <RemoveAudioSection />
      </Styled.MusicVersioningContainer>
    </>
  )
}

export default memo(MusicVersioning)
